import React from 'react';
import {fetchUtils, SelectInput, Button, TabbedForm, FormTab, Filter, BooleanInput, required, Toolbar, SaveButton, 
	DateField, Edit, Create, List, Datagrid, TextField, TextInput, DateInput, SelectArrayInput, FormDataConsumer,
  ReferenceArrayInput, AutocompleteArrayInput, ArrayInput, SimpleFormIterator, NumberInput} from 'react-admin';
import { NotificationManager } from 'react-notifications';
import DataTable from 'react-data-table-component';
import CloudDownload from '@material-ui/icons/CloudDownload';
import RunReportIcon from '@material-ui/icons/PlayCircleFilledRounded';
import SendIcon from '@material-ui/icons/Send';
import DeleteWithConfirmation from './components/DeleteWithConfirmation';

const utils = require('./components/utils');
const dataSupport = require('./components/data_support.js');

const DISCREPANCY_BIDDERS = [
	{ id: 152,  name: '152Media (152)' },
	{ id: 327,  name: 'AdaptMX (327)' },
	{ id: 312,  name: 'Appnexus (312)' },
	{ id: 313,  name: 'Appnexus Native (313)' },
	{ id: 400,  name: 'Appnexus Video (400)' },
	{ id: 326,  name: 'Appnexus 2(326)' },
	{ id: 330,  name: 'Appnexus 2 Native (330)' },
	{ id: 408,  name: 'Appnexus 2 Video (408)' },
	{ id: 420,  name: 'Audigent CTV (420)' },
	{ id: 361,  name: 'Audigent Banner (361)' },
	{ id: 362,  name: 'IMDS DM (362)' },
	{ id: 401,  name: 'Leanback CTV (401)' },
	{ id: 373,  name: 'MediaForce (373)' },
	{ id: 320,  name: 'Mediafuse Banner (320)' },
	{ id: 409,  name: 'Mediafuse Video (409)' },
	{ id: 348,  name: 'MinuteMedia Banner (348)' },
	{ id: 376,  name: 'Nexxen Banner (376)' },
	{ id: 431,  name: 'Nexxen Video (431)' },
	{ id: 381,  name: 'Nexxen Banner PBS (381)' },
	{ id: 435,  name: 'Nexxen Video PBS (435)' },
	{ id: 318,  name: 'OneTag (318)' },
	{ id: 352,  name: 'Rise (352)' },
	{ id: 424,  name: 'Rise Video (424)' },
	{ id: 323,  name: 'Rubicon/Magnite DM Banner (323)' },
	{ id: 347,  name: 'Rubicon/Magnite MF Banner (347)' },
	{ id: 351,  name: 'Sharethrough (351)' },
	{ id: 423,  name: 'Sharethrough Video(423)' },
	{ id: 332,  name: 'Sonobi (332)' },
	{ id: 411,  name: 'Sonobi Video (411)' },
	{ id: 310,  name: 'Sovrn (310)' },
	{ id: 413,  name: 'Sovrn Video (413)' },
	{ id: 339,  name: 'Yahoo Banner (339)' },
	{ id: 418,  name: 'Yahoo Video (418)' },
	{ id: 337,  name: 'Yahoo MF Banner (337)' },
	{ id: 410,  name: 'Yahoo MF Video (410)' },
	{ id: 346,  name: 'Zeta Disqus Banner (346)' },
	{ id: 422,  name: 'Zeta Disqus Video (422)' },
	{ id: 324,  name: 'Zeta Banner (324)' }
];

const fetch = fetchUtils.fetchJson;
const BASE_URL = window.nobid_endpoint + '/discrepancies_report';
const ALERT_URL = window.nobid_endpoint + '/discrepancies_alert';

function datePad(val) {
	if (val>=10) return ''+val;
	else return '0'+val;
}
function formatDate(date) {
	const ret = `${date.getFullYear()}-${datePad(date.getMonth()+1)}-${datePad(date.getDate())}`;
	return ret;
}
function defaultStartDate() {
	let ret = new Date();
	ret.setTime(ret.getTime() - 8*24*3600*1000);
	return ret;
}
function defaultEndDate() {
	return new Date();
}

const choicesInterval = [
	{ id: 'day', name: 'Daily' },
	{ id: 'week', name: 'Weekly' },
	{ id: 'month', name: 'Monthly' }
];
const dateRangeChoices = [
	{ id: '0', name: 'Today' },
	{ id: 1, name: 'Yesterday' },
	{ id: 2, name: 'Last 2 Days' },
	{ id: 3, name: 'Last 3 Days' },
  { id: 5, name: 'Last 5 Days' },
	{ id: 7, name: 'Last 7 Days' },
	{ id: 8, name: 'Last 8 Days' },
	{ id: 10, name: 'Last 10 Days' },
  { id: 15, name: 'Last 15 Days' },
	{ id: 30, name: 'Last 30 Days' },
  { id: 'lm', name: 'Last Month' },
  { id: 'mtd', name: 'Month to Date' },
  { id: 'mty', name: 'Month to Yesterday' },
  { id: 'ytd', name: 'Year to Date' },
  { id: 'yty', name: 'Year to Yesterday' },
	{ id: 'custom', name: 'Custom' }
];
let choicesShow = [
	{ id: 'date', name: 'Date' },
	{ id: 'publisher', name: 'Publisher' },
	{ id: 'placement', name: 'Placement' },
	{ id: 'bidder', name: 'Bidder' },
	{ id: 'ad_type', name: 'Ad Type'}
];
const DiscrepanciesTitle = ({ record }) => {
	return <span>Discrepancies Report {record ? `"${record.name}"` : ''}</span>;
};
const DiscrepanciesFilter = (props) => (
    <Filter {...props}>
        <TextInput label="Search" source="search_name" alwaysOn resettable />
    </Filter>
);
export const DiscrepanciesList = (props) => (
	<List {...props} title="Discrepancies Reports" perPage={25} bulkActionButtons={false} filters={<DiscrepanciesFilter />} 
	exporter={false} >
		<Datagrid rowClick="edit">
			<TextField source="name" label="Name" />
			<DateField source="updated_at" label="Update Date" />
			<DateField source="created_at" label="Creation Date" />
			<DeleteWithConfirmation {...props}/>
		</Datagrid>
	</List>
);
class CustomToolbar extends React.Component {
	state = {
	}
	constructor(props) {
		super(props);
		this.parent = props.parent;
	}
	fetchData() {
		function formDataFields(formData, fields) {
			const buf = [];
			for(let i in fields) {
				let field = fields[i];
				if (formData[field] && formData[field].length>0) {
					formData[field].map(x => buf.push(`${field}=${x}`));
				}
			}
			return buf.length>0 ? `&${buf.join('&')}` : '';
		}
		const serializeMetrics = () => {
      let buf = '';
      let metrics = formData.metric_filter;
      if (metrics) for (let i in metrics) {
        let r = metrics[i];
        if (r && r.metric && r.operator && r.value) {
          buf += '&metrics=' + r.metric + '|' + r.operator + '|' + r.value;
        }
      }
      return buf;
    }
		const metrics = serializeMetrics();
		let show='';
		if (formData.show) formData.show.forEach(item => { show+='&show='+item; });
		let interval = (formData.interval) ? `&interval=${formData.interval}` : '&interval=day';
		let dateRange = '';
		if (formData.date_range === 'custom') {
			let startDate = (typeof formData.start_date === 'object') ? formatDate(formData.start_date) : formData.start_date;
			let endDate = (typeof formData.end_date === 'object') ? formatDate(formData.end_date) : formData.end_date;
			if (startDate.indexOf('T') > 0) startDate = startDate.substring(0, startDate.indexOf('T'));
			if (endDate.indexOf('T') > 0) endDate = endDate.substring(0, endDate.indexOf('T'));
			dateRange = `&start_date=${startDate}&end_date=${endDate}`;
		} else {
			dateRange = `&date_range=${formData.date_range}`;
		}

		this.parent.setState({loading: true, total: '---'});
		let url = `${BASE_URL}?exclude_today=true${show}${interval}${dateRange}${metrics}`+
		`${formDataFields(formData, ['publisher_id', 'placement_id', 'site_id', 'bidder_id', 'tldomain', 'ad_type', 'exclude_today'])}`;
		let options = { headers: new Headers() };
		options.headers.set('accept', 'application/json');
		const token = localStorage.getItem('token');
		options.headers.set('Authorization', `Bearer ${token}`);
		fetch(url, options).then(({ headers, json }) => (
			this.parent.setState({data: json.data, loading: false, total: json.total})
		));
	}
	handleSearch = () => {
		this.fetchData();
	}
	handleAlert = () => {
		const processResponse = (response) => {
			const title = 'Server Notification';
			if (response && response.success) {
				NotificationManager.success(response.message, title);
			} else if (response) {
				NotificationManager.warning(response.message, title);
			} else {
				NotificationManager.error('No response from the server', 'Client Notification');
			}
		}
		let options = { headers: new Headers() };
		options.headers.set('accept', 'application/json');
		const token = localStorage.getItem('token');
		options.headers.set('Authorization', `Bearer ${token}`);
		const url = `${ALERT_URL}?id=${this.parent.props.id}`;
		fetch(url, options).then(({ headers, json }) => (
		  processResponse(json)
		));
	}
	render() {
		return <Toolbar>
			<SaveButton style={{marginRight: '25px'}} variant='contained' 
				color='primary' disabled={this.props.parent.state.loading} {...this.props} />
			<br />
			<Button label='Run Report' onClick={this.handleSearch} props={this} variant='contained' color='primary' 
				startIcon={<RunReportIcon />} style={{marginRight: '5px', padding: '7px', width: '160px'}} 
				disabled={this.props.parent.state.loading} />
			<br />
			{this.parent.props.formType==='edit' &&
				<span>
				<Button label='Alert Saved Report' onClick={this.handleAlert} props={this} variant='contained' color='primary' 
					startIcon={<SendIcon />} style={{marginRight: '5px', padding: '7px', width: '220px'}} 
					disabled={this.props.parent.state.loading} />
				<DateField source="updated_at" label="Update date" style={{ padding: '10px' }} showTime />
				<TextField source="updated_name" label="" style={{ padding: '10px' }} />
				</span>
		  }
		</Toolbar>
	}
};
let formData = {};
function setFormData(formdata) {
	formData = formdata;
}
class DiscrepanciesForm extends React.Component {
	state = {
		date_range : this.props.record.date_range,
	};
	render(props) {
		return (
			<TabbedForm toolbar={<CustomToolbar parent={this.props.parent} />} redirect='edit' {...this.props}>
			<FormTab label="Report Settings">
				<BooleanInput source="exclude_today" defaultValue={true} style={{display: 'none'}}/>
				<TextInput source="name" label="Report Name" style={{ width: '400px' }} validate={required()} />
				<FormDataConsumer>
					{({ formData }) => setFormData(formData) }
				</FormDataConsumer>
				<div style={{ width: '100%', overflow: 'hidden' }}>
					<div style={{ float: 'left', paddingRight: '5px' }}>
						<SelectInput label="Interval" source="interval"
						choices={choicesInterval}
						defaultValue='day'
						disabled={this.props.parent.loading} />
					</div>
					<div style={{ float: 'left', paddingRight: '5px' }}>
						<SelectInput label="Date Range" source="date_range"
						choices={dateRangeChoices}
						onChange={value => this.setState({ date_range: value.target.value })}
						defaultValue="8"
						disabled={this.props.parent.loading} />

						<div style={{ float: 'right', paddingLeft: '5px', display: ('custom' !== this.state.date_range) ? 'none' : 'block' }}>
						<div style={{ float: 'left', paddingRight: '5px', display: ('custom' !== this.state.date_range) ? 'none' : 'block' }}>
							<DateInput label="Start Date" source="start_date" allowEmpty
							disabled={this.props.parent.loading}
							initialValue={defaultStartDate()}
							style={{ display: ('custom' !== this.state.date_range) ? 'none' : 'block' }} />
						</div>

						<div style={{ float: 'left', display: ('custom' !== this.state.date_range) ? 'none' : 'block' }}>
							<DateInput label="End Date" source="end_date" allowEmpty
							disabled={this.props.parent.loading}
							initialValue={defaultEndDate()}
							style={{ display: ('custom' !== this.state.date_range) ? 'none' : 'block' }} />
						</div>
						</div>
					</div>
					<div style={{ float: 'left', paddingRight: '5px' }}>
						<SelectArrayInput label="Show"
						source="show"
						choices={choicesShow}
						defaultValue={['date']}
						style={{ width: '400px' }}
						disabled={this.props.parent.loading} />
					</div>
				</div>
				<div style={{ width: '100%', overflow: 'hidden' }} id="wrapper3">
					
					<div style={{ float: 'left', paddingRight: '5px' }}>
					<ReferenceArrayInput 
						source="publisher_id" 
						label="Publishers" 
						reference="discrepancies_publishers"
						basePath="discrepancies_publishers"
						perPage={15} 
						sort={{ field: 'name', order: 'ASC' }}
						filterToQuery={searchText => ({ search_name: searchText })}
						allowEmpty
						disabled={this.props.parent.loading}>
						<AutocompleteArrayInput disabled={this.props.parent.loading} 
            optionText={x => (x && x.code) ? `${x.name} (${x.code})` : ''}
            optionValue="code"/>
					</ReferenceArrayInput>
					</div>
					
					<div style={{ float: 'left', paddingRight: '5px' }}>
					<ReferenceArrayInput 
						source="placement_id" 
						label="Placements" 
						reference="discrepancies_placements"
						basePath="discrepancies_placements"
						perPage={15} 
						sort={{ field: 'name', order: 'ASC' }}
						filterToQuery={searchText => ({ search_name: searchText })}
						allowEmpty
						disabled={this.props.parent.loading}>
						<AutocompleteArrayInput disabled={this.props.parent.loading} 
							optionText={x => (x && x.code) ? `${x.name} (${x.code})` : ''}
							optionValue="code"/>
					</ReferenceArrayInput>
					</div>

					<div style={{ float: 'left', paddingRight: '5px' }}>
					<SelectArrayInput source="bidder_id" label="Bidder" 
						allowEmpty
						disabled={this.props.parent.loading}
            choices={DISCREPANCY_BIDDERS}	
            style={{ width: '250px' }}
					/>
					</div>

					<div style={{ float: 'left', paddingRight: '5px' }}>
					<SelectArrayInput label="Ad Type" 
					source="ad_type" 
					choices={[
						{ id: 'banner', name: 'BANNER' },
            { id: 'native', name: 'NATIVE' },
						{ id: 'video',  name: 'VIDEO' }
					]} 
					style={{ width: '150px' }}
					disabled={this.props.parent.loading} />
					</div>

				</div>
				<BooleanInput label='Daily Alert' source='schedule'/>
				<FormDataConsumer style={{ width: '100%'}}> 
					{({ formData, ...rest }) => (formData.schedule) &&
					  <div style={{ width: '100%', overflow: 'hidden' }}>
							<div style={{ float: 'left', paddingRight: '5px', paddingTop: '25px' }}>Number of records</div>
							<div style={{ float: 'left', paddingRight: '5px' }}>
							  <SelectInput label='Is' source='schedule_operator' choices={[
								  { id: 'eq', name: 'Equals' },
								  { id: 'gt', name: 'Greater than' },
								  { id: 'lt', name: 'Less than' }]} />
							</div>
							<div style={{ float: 'left', paddingRight: '5px' }}>
							  <NumberInput label='Value' source='schedule_value' step={1} />
							</div>
							<div style={{ float: 'left', paddingRight: '5px', width: '6	00px' }}>
							  <TextInput label='Emails Recipients (comma separated)' source='schedule_emails' style={{ width: '600px' }}/>
							</div>
						</div>
					}
        </FormDataConsumer>

				<div style={{ width: '70%' }}>
				<ArrayInput source="metric_filter">
						<SimpleFormIterator>
						<SelectInput source='metric' label="Select Metric" choices={metricChoices} style={{float: 'left', paddingLeft: '10px'}}/>
						
						<SelectInput source='operator' label="Select Operator" style={{float: 'left', paddingLeft: '10px'}}
							choices={[{ id: 'eq', name: 'Equals' },{ id: 'gt', name: 'Greater than' },{ id: 'lt', name: 'Less than' }]} />
						
            <NumberInput source='value' label='Value' style={{float: 'left', paddingLeft: '10px'}}></NumberInput>
						</SimpleFormIterator>
				</ArrayInput>
				</div>
			</FormTab>
			</TabbedForm>
		)
	}
}
let BASE_COLUMNS = [
	{ name: 'Date', selector: 'date', sortable: true, cell: row => ('' + row.date) },
	{ name: 'Publisher', selector: 'publisher_name', sortable: true, cell: row => <span>{ `${row.publisher_name} (${row.publisher_id})` }</span> },
	{ name: 'Placement', selector: 'placement_name', sortable: true, cell: row => <span>{ `${row.placement_name} (${row.placement_id})` }</span> },
	{ name: 'Bidder', selector: 'bidder_name', sortable: true, cell: row => <span>{ `${row.bidder_name} (${row.bidder_id})` }</span> },
	{ name: 'Ad Type', selector: 'ad_type', sortable: true, cell: row => <span>{ `${row.ad_type?row.ad_type.toUpperCase():'NA'}` }</span> },
	{ name: 'Requests', selector: 'requests', sortable: true, cell: row => utils.formatLong(row.requests) },
	{ name: 'Impressions', selector: 'impressions', sortable: true, cell: row => utils.formatLong(row.impressions) },
	{ name: '$ Revenue', selector: 'revenue', sortable: true, cell: row => utils.formatDouble(row.revenue) },
  { name: 'NoBid Impressions', selector: 'nobid_impressions_adjusted', sortable: true, cell: row => utils.formatLong(row.nobid_impressions_adjusted) },
	{ name: '$ NoBid Revenue', selector: 'nobid_revenue_adjusted', sortable: true, cell: row => utils.formatDouble(row.nobid_revenue_adjusted) },
  { name: '$ NoBid Net Revenue', selector: 'nobid_net_revenue_adjusted', sortable: true, cell: row => utils.formatDouble(row.nobid_net_revenue_adjusted) },
	{ name: 'Impressions Spread', selector: 'impressions_spread', sortable: true, cell: row => utils.formatLong(row.impressions_spread) },
	{ name: '$ Revenue Spread', selector: 'revenue_spread', sortable: true, cell: row => utils.formatDouble(row.revenue_spread) },
	{ name: '% Impressions Disrepancy', selector: 'impressions_discrepancy', sortable: true, cell: row => utils.formatDouble(row.impressions_discrepancy, ' ') },
	{ name: '% Revenue Disrepancy', selector: 'revenue_discrepancy', sortable: true, cell: row => utils.formatDouble(row.revenue_discrepancy, ' ') },
];
let columns = [];
const conditionalRowStyles = [
	{   
			when: row => (row.response_rate <= 5 || row.fill_rate <= 0),
			style: {color: 'red', backgroundColor: 'white'}
	},
	{   
		when: row => (row.response_rate >= 10  && row.fill_rate >= 0.5),
			style: {color: 'green', backgroundColor: 'white'}
	},
];
const metricChoices = [
	{ id: 'requests', name: 'Requests' },
  { id: 'impressions', name: 'Impressions' },
	{ id: 'nobid_impressions', name: 'NoBid Impressions' },
	{ id: 'revenue', name: '$Revenue' },
	{ id: 'nobid_revenue', name: '$NoBid Revenue' },
	{ id: 'impressions_spread', name: 'Impressions Spread' },
	{ id: 'revenue_spread', name: '$Revenue Spread' },
	{ id: 'impressions_discrepancy', name: '%Impressions Discrepancy' },
	{ id: 'revenue_discrepancy', name: '%Revenue Discrepancy' }
];
class DiscrepanciesUpsert extends React.Component {
	state = {
		data: [],
		loading: false,
		total: '---'
	};
	setState(obj) {
		if (obj.data && obj.data.length>0) {
			let keys = Object.keys(obj.data[0]);
			columns = BASE_COLUMNS.filter( item => { return keys.includes(item.selector) } );
		}
		super.setState(obj);
	}
	render(props) {
		const { data, loading, total } = this.state;
		return (
		<div>
			{this.props.formType === "edit" &&
				<Edit title={<DiscrepanciesTitle />} {...this.props}>
					<DiscrepanciesForm formType="edit" parent={this}/>
				</Edit>
			}
			{this.props.formType === "create" &&
				<Create title="Create Discrepancies Report" {...this.props}>
					<DiscrepanciesForm formType="create" parent={this}/>
				</Create>
			}
			<DataTable
				title={`${total} Matching Results`}
				theme="dark"
				columns={columns}
				data={data}
				progressPending={loading}
				pagination
				fixedHeader
				dense
				conditionalRowStyles={conditionalRowStyles}
				paginationPerPage={30}
				paginationRowsPerPageOptions={[10, 20, 30, 50, 100]}
				subHeader={!loading}
				subHeaderComponent={
					(
					<div style={{ display: 'flex', alignItems: 'center' }}>
						<input type="text" id='search_box' label="Search"
						variant="outlined"
						style={{ margin: '5px' }}
						onChange={(target) => dataSupport.filterData(this)} />
						<CloudDownload
						label="Export"
						style={{ margin: '5px' }}
						color="action"
						onClick={() => dataSupport.exportData(this.state.data)}
						/>
					</div>
					)
				}
			/>
		</div>
		)
	}
}

export const DiscrepanciesEdit = (props) => (
	<DiscrepanciesUpsert formType="edit" {...props} />
);

export const DiscrepanciesCreate = (props) => (
	<DiscrepanciesUpsert formType="create" {...props} />
);